<template>
    <div>
        <!-- 上部按钮 -->
        <div class="editbbutton">
            <div>
                <el-tabs v-model="editstep" type="card" >
                    <el-tab-pane label="基本信息" name="1"></el-tab-pane>
                    <el-tab-pane label="证件资料" name="2"></el-tab-pane>
                    <!-- 村级 -->
                    <el-tab-pane label="审核操作" name="3" v-if="markshow==6"></el-tab-pane>
                    <!-- 乡级 -->
                    <el-tab-pane label="审核操作" name="3" v-if="markshow==1"></el-tab-pane>
                    <!-- 区级 -->
                    <el-tab-pane label="审核操作" name="3" v-if="markshow==2"></el-tab-pane>
                    <!-- 重申 -->
                    <!-- 村级 -->
                     <el-tab-pane label="重审操作" name="3" v-if="markshow==7"></el-tab-pane>
                       <!-- 乡级 -->
                    <el-tab-pane label="重审操作" name="3" v-if="markshow==3"></el-tab-pane>
                    <!-- 区级 -->
                     <el-tab-pane label="重审操作" name="3" v-if="markshow==5"></el-tab-pane>
                    <!-- 年审审核 markshow==4(markauditStatusID == 1||markauditStatusID == 2) -->
                   <!-- {{markauditStatus}} -->
                    <el-tab-pane label="年审操作" name="4" v-if="markshow==4&& (region_level == 4||region_level == 5) && markauditStatus==1"></el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div style="margin-top:30px" v-if="editstep==1">
            <!-- 政策措施 -->
            <div class="searchcontent descriptionsheight" >
                <div class="title">
                    <i class="el-icon-setting"></i>
                     {{policyMeasureTitle}}
                </div>
                <el-descriptions    :model="dateContent"  :column="1" :size="size" border >
                        <el-descriptions-item>
                            <template slot="label"> 
                            政策措施:
                            </template>
                            {{policyMeasureName}}
                        </el-descriptions-item>
                </el-descriptions>
             </div>
            <!-- 本人信息 -->
            <div class="searchcontent descriptionsheight" >
                <div class="title">
                    <i class="el-icon-setting"></i>本人信息
                </div>
                <el-descriptions  class="margin-top"  :model="dateContent"  :column="4" :size="size" border>
                    <template slot="extra">
                    </template>
                        <el-descriptions-item>
                            <template slot="label"  >
                                姓名：
                            </template>
                                {{dateContent.realName}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                性别：
                            </template>
                            <span v-if="dateContent.sexID==1">男</span>
                            <span v-if="dateContent.sexID==2">女</span>
                        </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label"> 
                            出生日期：
                            </template>
                            {{dateContent.userBirthday}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label"> 
                            证件号：
                            </template>
                            {{dateContent.certificateNo}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                               户口性质：
                            </template>
                            <span v-if="dateContent.accountNature==1">农业</span>
                            <span v-if="dateContent.accountNature==2">非农业</span>
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                婚姻状况：
                            </template>
                            <span v-if="dateContent.maritalStatus==1">初婚</span>
                            <span v-if="dateContent.maritalStatus==2">再婚</span>
                            <span v-if="dateContent.maritalStatus==3">离婚</span>
                            <span v-if="dateContent.maritalStatus==4">丧偶</span>
    
                        </el-descriptions-item>
                        
                        <el-descriptions-item>
                        <template slot="label" >  
                        婚姻变动日期：
                        </template>
                        {{dateContent.marriageChanges}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label" >  
                        工作单位：
                        </template>
                        {{dateContent.workUnit}}
                        </el-descriptions-item>
                        
                </el-descriptions>
                <el-descriptions  class="eldescriptionstop"  :model="dateContent"  :column="2" :size="size" border >
                        <el-descriptions-item>
                            <template slot="label"> 
                            享受地户籍：
                            </template>
                            {{dateContent.lsRegionParentInfo1}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> 
                            原户籍地址详情：
                            </template>
                            {{dateContent.enjoyCensusAddress}}
                        </el-descriptions-item>
                </el-descriptions>
                <el-descriptions  class="eldescriptionstop"  :model="dateContent"  :column="2" :size="size" border >
                        <el-descriptions-item>
                            <template slot="label"> 
                            现户籍地址：
                            </template>
                            {{dateContent.lsRegionParentInfo2}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> 
                            现居住详情地址：
                            </template>
                            {{dateContent.currentCensusAddress}}
                        </el-descriptions-item>
                </el-descriptions>
            </div>
            <!-- 配偶信息 -->
            <div class="searchcontent descriptionsheight"  v-if="dateContent.maritalStatus==1 || dateContent.maritalStatus==2">
                <div class="title">
                    <i class="el-icon-setting"></i>配偶信息
                </div>
                <el-descriptions  class="margin-top"  :model="dateContent01"  :column="3" :size="size" border>
                    <template slot="extra">
                        </template>
                        <el-descriptions-item>
                            <template slot="label"  >
                                姓名：
                            </template>
                                {{dateContent01.realName}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                性别：
                            </template>
                            <span v-if="dateContent01.sexID==1">男</span>
                            <span v-if="dateContent01.sexID==2">女</span>
                        </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label"> 
                            出生日期：
                            </template>
                            {{dateContent01.userBirthday}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label"> 
                            证件号：
                            </template>
                            {{dateContent01.certificateNo}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                               户口性质：
                            </template>
                            <span v-if="dateContent01.accountNature==1">农业</span>
                            <span v-if="dateContent01.accountNature==2">非农业</span>
                        </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label">
                        婚姻状况：
                        </template>
                       <span v-if="dateContent01.maritalStatus==1">初婚</span>
                        <span v-if="dateContent01.maritalStatus==2">再婚</span>
                        <span v-if="dateContent01.maritalStatus==3">离婚</span>
                        <span v-if="dateContent01.maritalStatus==4">丧偶</span>
                        
                        </el-descriptions-item>
                        
                        <el-descriptions-item>
                        <template slot="label" >  
                        婚姻变动日期：
                        </template>
                        {{dateContent01.marriageChanges}}
                        </el-descriptions-item>
                         <el-descriptions-item>
                            <template slot="label"> 
                            享受地户籍：
                            </template>
                            {{dateContent01.lsRegionParentInfo1}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> 
                            原户籍地址详情：
                            </template>
                            {{dateContent01.enjoyCensusAddress}}
                        </el-descriptions-item>
                        
                </el-descriptions>
                <!-- <el-descriptions  class="eldescriptionstop"  :model="dateContent01"  :column="2" :size="size" border >
                        <el-descriptions-item>
                            <template slot="label"> 
                            享受地户籍：
                            </template>
                            {{dateContent01.lsRegionParentInfo1}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> 
                            原户籍地址详情：
                            </template>
                            {{dateContent01.enjoyCensusAddress}}
                        </el-descriptions-item>
                </el-descriptions> -->
            </div>
            <!-- 子女信息 -->
            <div class="searchtable descriptionsheight"  >
                <div class="title">
                    <i class="el-icon-setting"></i>子女信息
                </div>
                <div v-for="(item,k) in dateContent03" :key="k" style="margin-top:15px">
                     <el-descriptions  class="margin-top"  :model="item"  :column="3" :size="size" border>
                        <template slot="extra">
                            </template>
                            <el-descriptions-item>
                            <template slot="label"  >
                                姓名：
                            </template>
                                {{item.zp1}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label">
                                性别：
                            </template>
                            <span v-if="item.zp2==1">男</span>
                            <span v-if="item.zp2==2">女</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label"> 
                            出生日期：
                            </template>
                            {{item.zp3}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label"> 
                            身份证号：
                            </template>
                             {{item.zp4}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label">
                            与父亲的关系：
                            </template>
                              {{item.zp5}}
                            
                            </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label">
                            与母亲的关系：
                            </template>
                              {{item.zp6}}
                            </el-descriptions-item>
                             <el-descriptions-item>
                            <template slot="label">
                            户籍地址：
                            </template>
                              {{item.zp19}}
                            </el-descriptions-item>
                             <el-descriptions-item v-if="policyMeasureID!=3">
                            <template slot="label">
                            是否本地子女：
                            </template>
                                <span v-if="item.zp20==1">本地子女</span>
                                <span v-if="item.zp20==0">异地子女</span>
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp7==4">
                                <template slot="label"> 
                                身体状况：
                                </template>
                                {{item.zp17}}
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp7==4">
                                <template slot="label"> 
                                死亡单位：
                                </template>
                                {{item.zp12}}
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp7==4">
                                <template slot="label"> 
                                死亡日期：
                                </template>
                                {{item.zp18}}
                            </el-descriptions-item>
                             <el-descriptions-item v-if="item.zp7==2">
                                <template slot="label"> 
                                残疾账号：
                                </template>
                                {{item.zp8}}
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp7==2">
                                <template slot="label"> 
                                残疾类型：
                                </template>
                                {{item.zp9}}
                            </el-descriptions-item >
                                <el-descriptions-item v-if="item.zp7==2">
                                <template slot="label"> 
                                残疾等级：
                                </template>
                                {{item.zp10}}
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp7==2">
                                <template slot="label"> 
                                残疾日期：
                                </template>
                                {{item.zp11}}
                            </el-descriptions-item>
                            
                    </el-descriptions>
             
                    <!-- 身体状况 -->
                     <el-descriptions  class="eldescriptionstop"  :model="item"  :column="1" :size="size" border v-if="item.zp7==1 || item.zp7==3">
                            <el-descriptions-item>
                                <template slot="label"> 
                                身体状况：
                                </template>
                                {{item.zp17}}
                            </el-descriptions-item>
                    </el-descriptions>
                    <!-- 是否收养 -->
                    <el-descriptions  class="eldescriptionstop"  :model="item"  :column="3" :size="size" border >
                            <el-descriptions-item>
                                <template slot="label"> 
                                是否收养：
                                </template>
                                <span v-if="item.zp13==1">是</span>
                                <span v-if="item.zp13==0">否</span>
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp13==1">
                                <template slot="label"> 
                                收养日期：
                                </template>
                                {{item.zp16}}
                            </el-descriptions-item>
                            <el-descriptions-item v-if="item.zp13==1">
                                <template slot="label"> 
                                被收养身份：
                                </template>
                                {{item.zp15}}
                            </el-descriptions-item>
                    </el-descriptions>
                </div>
            </div>
            <!-- 数量 -->
            <div class="searchcontent descriptionsheight" >
                <el-descriptions  class="margin-top"  :model="dateContent05"  :column="3" :size="size" border>
                    <template slot="extra">
                        </template>
                        <el-descriptions-item>
                        <template slot="label"> 
                        曾生育子女及收养子女数：
                        </template>
                        {{dateContent05.totalChildrenNum}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label"> 
                        男孩数：
                        </template>
                        {{dateContent05.totalChildrenBoyNum}}
                    </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label"> 
                        女孩数：
                        </template>
                        {{dateContent05.totalChildrenGirlNum}}
                    </el-descriptions-item>
                     <el-descriptions-item>
                        <template slot="label"> 
                        现有存活子女数：
                        </template>
                        {{dateContent05.surviveChildrenNum}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label"> 
                        男孩数：
                        </template>
                        {{dateContent05.surviveChildrenBoyNum}}
                    </el-descriptions-item>
                        <el-descriptions-item>
                        <template slot="label"> 
                        女孩数：
                        </template>
                        {{dateContent05.surviveChildrenGirlNum}}
                    </el-descriptions-item>
                        
                </el-descriptions>
            </div>

            <!-- 其他信息 -->
            <div class="searchcontent descriptionsheight" >
                <div class="title">
                    <i class="el-icon-setting"></i>其他信息
                </div>
                <el-descriptions  class="margin-top"  :model="dateContent"  :column="4" :size="size" border>
                    <template slot="extra">
                        </template>
                        <!-- <el-descriptions-item>
                        <template slot="label"  >
                            银行账号：
                        </template>
                            {{dateContent.bankAccount}}
                        </el-descriptions-item> -->
                        <el-descriptions-item>
                        <template slot="label">
                            联系电话：
                        </template>
                        {{dateContent.contactTel}}
                        </el-descriptions-item>
                        <!-- dateContent.accountNature==2 -->
                        <el-descriptions-item v-if="policyMeasureID==3"> 
                            <template slot="label"> 
                            养老保险类型：
                            </template>
                            {{dateContent.pensionInsuranceCategoryName}}
                        </el-descriptions-item>
                        <el-descriptions-item v-if="policyMeasureID==3">
                            <template slot="label"> 
                            退休证号：
                            </template>
                            {{dateContent.retirementCertificateNumber}}
                        </el-descriptions-item>
                        
                </el-descriptions>
                <el-descriptions  class="eldescriptionstop"  :model="dateContent"  :column="3" :size="size" border v-if="policyMeasureID==3" >
                        <el-descriptions-item>
                            <template slot="label"> 
                               退休金单位：
                            </template>
                            {{dateContent.retirementPaymentUnit}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> 
                              退休日期：
                            </template>
                               {{dateContent.retirementTime}}
                        </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label"> 
                            退休金发放地：
                            </template>
                               {{dateContent.lsRegionParentInfo3}}
                        </el-descriptions-item>
                         <el-descriptions-item>
                            <template slot="label"> 
                            户口迁入本省日期：
                            </template>
                            {{dateContent.censusMoveInTime}}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> 
                            户口迁出本省日期：
                            </template>
                            {{dateContent.censusMoveOutTime}}
                        </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label"> 
                            户口迁出地：
                            </template>
                            {{dateContent.censusEmigrationPlace}}
                        </el-descriptions-item>
                        
                </el-descriptions>
                
            </div>


        </div>
        <!-- 图集 -->
        <div   v-if="editstep==2" class="searchtable descriptionsheight searchtableimglist"  >
            <div>
                <div class="title">
                    <i class="el-icon-setting"></i>本人身份证信息
                </div>
                <div class="searchtable-img">
                    <div class="searchtable-item">
                      <el-popover placement="right" title trigger="hover">
                        <img :src="img1" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img1"
                            class="imageitem"
                        />
                       </el-popover>
                       <div class="searchtable-text">身份证正面</div>
                    </div>
                     <div class="searchtable-item">
                      <el-popover placement="right" title trigger="hover">
                        <img :src="img2" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img2"
                            class="imageitem"
                        />
                       </el-popover>
                       <div class="searchtable-text">身份证反面</div>
                    </div>
                </div>
            </div>
            <div>
                <div class="title" >
                    <i class="el-icon-setting"></i>本人户口信息
                </div>
                <div class="searchtable-img">
                    <div class="searchtable-item">
                      <el-popover placement="right" title trigger="hover">
                        <img :src="img3" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img3"
                            class="imageitem"
                        />
                       </el-popover>
                       <div class="searchtable-text">首页</div>
                    </div>
                    <div class="searchtable-item">
                      <el-popover placement="right" title trigger="hover">
                        <img :src="img4" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img4"
                            class="imageitem"
                        />
                       </el-popover>
                       <div class="searchtable-text">本人页</div>
                    </div>
                    
                </div>
            </div>
            <!-- 配偶 -->
            <div v-if="dateContent.maritalStatus==1 || dateContent.maritalStatus==2">
                <div class="title" style="margin-top:30px">
                    <i class="el-icon-setting"></i>配偶户口信息
                </div>
                <div class="searchtable-img">
                     <div class="searchtable-item">
                      <el-popover placement="right" title trigger="hover">
                        <img :src="img5" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img5"
                            class="imageitem"
                        />
                       </el-popover>
                       <div class="searchtable-text">首页</div>
                    </div>
                     <div class="searchtable-item">
                      <el-popover placement="right" title trigger="hover">
                        <img :src="img6" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img6"
                            class="imageitem"
                        />
                       </el-popover>
                       <div class="searchtable-text">本人页</div>
                    </div>
                </div>
            </div>
            <div>
             <!-- <div v-if="dateContent.maritalStatus==1 || dateContent.maritalStatus==2"> -->
                <div class="title" style="margin-top:30px">
                    <i class="el-icon-setting"></i>婚姻证明信息：
                </div>
                <div class="searchtable-img">
                    <div class="searchtable-item">
                        <el-popover placement="right" title trigger="hover">
                            <img :src="img9" style="max-height: 800px;max-width: 800px" />
                            <img
                                slot="reference"
                                :src="img9"
                                class="imageitem"
                            />
                        </el-popover>
                    </div>
                </div>
            </div> 

            <div v-if="img7!=''">
                <div class="title" style="margin-top:30px">
                        <i class="el-icon-setting"></i>独生子女光荣证：
                </div>
                <div class="searchtable-img">
                    <div class="searchtable-item">
                        <el-popover placement="right" title trigger="hover">
                            <img :src="img7" style="max-height: 800px;max-width: 800px" />
                            <img
                                slot="reference"
                                :src="img7"
                                class="imageitem"
                            />
                        </el-popover>
                    </div>
                </div>
            </div> 
            <div style="width:100% !important" v-if="isWhethertoadopt==true">
                <div class="title" style="margin-top:30px">
                    <i class="el-icon-setting"></i>收养证：
                </div>
                <div class="searchtable-img">
                    <div class="searchtable-item">
                    <!-- <el-card :body-style="{ padding: '0px' }" >
                        <img :src="img8">
                    </el-card> -->
                     <el-popover placement="right" title trigger="hover">
                        <img :src="img8" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="img8"
                            class="imageitem"
                        />
                    </el-popover>
                    </div>
                </div>
            </div> 
           
            <div style="width:100% !important" v-if="isdisability==true">
                <div class="title" style="margin-top:30px">
                    <i class="el-icon-setting"></i>残疾证明信息
                </div>
                <div class="searchtable-img">
                   
                    <div v-for="(m,n) in img10" :key="n" class="searchtable-item">
                        <!-- <el-card :body-style="{ padding: '0px' }" class="imageitem">
                            <img :src="m.url">
                        </el-card> -->
                        <el-popover placement="right" title trigger="hover">
                        <img :src="m.url" style="max-height: 800px;max-width: 800px" />
                        <img
                            slot="reference"
                            :src="m.url"
                            class="imageitem"
                        />
                    </el-popover>
                    </div>
                </div>
            </div> 
        </div>
        <!-- 申报审核  年审审核   重申 -->
        <div  v-if="editstep==3">
            <div class="checkedForm">
                <el-form ref="checkedForm"  label-width="130px" :model="checkedForm">
                    <el-form-item label="是否通过" >
                        <el-radio v-model="checkedForm.is_audit_pass" label="0">否</el-radio>
                        <el-radio v-model="checkedForm.is_audit_pass" label="1">是</el-radio>
                    </el-form-item>
                    <el-form-item label="不通过原因：" prop="people_logout_reason_id"  v-if="checkedForm.is_audit_pass==`0`">
                            <el-select size="medium" v-model="checkedForm.noPassReason" placeholder="请选择不通过原因" style="width:250px" >
                                <el-option
                                v-for="item in checkedForm.noPassReasonList"
                                :key="item.systemCodeID"
                                :label="item.systemCodeName"
                                :value="item.systemCodeID">
                                </el-option>
                            </el-select>
                    </el-form-item>   
                    <el-form-item label="不通过原因：" prop="noPassReasontext"  class="textarea"  v-if="checkedForm.is_audit_pass==`0`">
                            <el-input
                                
                                type="textarea"
                                maxlength="1000"
                                :rows="4"
                                placeholder="请输入不通过原因(最多可录入1000字)"
                                v-model.trim="checkedForm.noPassReasontext">
                                </el-input>
                    </el-form-item>   
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <!-- <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button> -->
                    <!-- 年审审核 -->
                    <el-button size="medium" type="primary"  @click="oncheckSubmit" v-if="markshow==4" :disabled='region_level != 4'>确 定</el-button>
                    <!-- 申报审核 -->
                    <el-button size="medium" type="primary"  @click="oncheckSubmitvillageship" v-if="markshow==6" :disabled='region_level != 6'>确 定</el-button>
                    <el-button size="medium" type="primary"  @click="oncheckSubmittownship" v-if="markshow==1" :disabled='region_level != 5'>确 定</el-button>
                    <el-button size="medium" type="primary"  @click="oncheckSubmitdistrict" v-if="markshow==2" :disabled='region_level != 4'>确 定</el-button>
                    <!-- 重申 -->
                     <!-- 村级 -->
                    <el-button size="medium" type="primary"  @click="oncheckSubmitreiterate" v-if="markshow==7" :disabled='region_level != 6'>确 定</el-button>
                    <!-- 乡级 -->
                    <el-button size="medium" type="primary"  @click="oncheckSubmitreiterate" v-if="markshow==3" :disabled='region_level != 5'>确 定</el-button>
                    <!-- 区级 -->
                    <el-button size="medium" type="primary"  @click="oncheckSubmitreiterate" v-if="markshow==5" :disabled='region_level != 4'>确 定</el-button>
                </div>
            </div>
        </div>
         <div  v-if="editstep==4">
            <div>
                <el-form ref="checkedForm"  label-width="130px" :model="ncheckedForm">
                    <el-form-item label="审核年份：">
                        <el-select size="small"   style="width:250px" v-model="ncheckedForm.year" placeholder="请选择年份" @change="checkedFormyearChange(checkedForm.year)">
                            <el-option
                            v-for="item in ncheckedForm.arrYear"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核日期：" >
                        <el-date-picker
                           style="width:250px"
                            size="medium"
                            format="yyyy-MM-dd"
                            v-model="ncheckedForm.stattime"
                            value-format="timestamp"
                            type="date"
                            placeholder="请选择审核日期"
                            :picker-options="pickerOptions2"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="是否通过" >
                        <el-radio v-model="ncheckedForm.is_audit_pass" label="0">否</el-radio>
                        <el-radio v-model="ncheckedForm.is_audit_pass" label="1">是</el-radio>
                    </el-form-item>
                    <el-form-item label="不通过原因：" prop="people_logout_reason_id"  v-if="ncheckedForm.is_audit_pass==`0`">
                            <el-select size="medium" v-model="ncheckedForm.noPassReason" placeholder="请选择不通过原因" style="width:250px" @change="selectchange">
                                <el-option
                                style="width:250px"
                                v-for="item in ncheckedForm.noPassReasonList"
                                :key="item.systemCodeID"
                                :label="item.systemCodeName"
                                :value="item.systemCodeID">
                                </el-option>
                            </el-select>
                    </el-form-item> 
                     <el-form-item   v-if="ncheckedForm.systemCode==99">
                        <div icon="el-icon-search" style="color:red">跨地区迁移个案不能选其他做退出处理，请到所属地变更操作</div>
                    </el-form-item>    
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <!-- 年审审核 -->
                    <el-button size="medium" type="primary"  @click="oncheckSubmit" v-if="markshow==4">确 定</el-button>   
                </div>
            </div>
        </div>
        <!-- <div  v-if="editstep==4"></div> -->
    </div>
</template>
<script>
import { policydeclarationinfoModule ,rewardannualreviewuserlistModel} from "@/request/windowtoaccept.js";
import { applyauditModel,applyaudit2Model } from "@/request/applyauditmanage.js";
import {publicFun} from '@/tools/time.js'
import { systemcodeModule } from "@/request/systemmange.js";
import store from '@/store'
export default {
    // ["valueID","indexID","markID","markrewardRecord","markpolicyMeasure","markuser","markshow","markregion","markauditStatusID"],
    props: ["valueID","indexID","markID","markrewardRecord","markpolicyMeasure","markuser","markshow","markauditStatus","filterShowdata"],
    name: "Particulars",
   
  data() {
      
    return {
        pickerOptions2: {
            disabledDate: (time) => {
                    if (this.checkedForm.stattime != "") {
                        return time.getTime() > Date.now() ;
                    } else {
                        return time.getTime() > Date.now();
                    }
            },
        },
    // 展示残疾的图片
    isdisability:false,
    isWhethertoadopt:false,
      size:'',
      childListlist:[], 
      editstep:'1',
      dateContent:{},
      dateContent01:{},
      dateContent03:[],
      dateContent04:{},
      dateContent05:{},
      img1:'',
      img2:'',
      img3:'',
      img4:'',
      img5:'',
      img6:'',
      img7:'',
      img8:'',
      img9:'',
      img10:[],
      policyMeasureID:0,
    // 审核
    checkedForm:{
        is_audit_pass: "0",
        noPassReason:'',
        noPassReasonList:[],
        noPassReasontext:'',
        apply_record_ids:'',
        user_ids:'',
        policy_measure_id:'',
        type:0,
       
     },
    ncheckedForm:{
        is_audit_pass: "0",
        noPassReason:'',
        systemCode:'',
        noPassReasonList:[],
        noPassReasontext:'',
        apply_record_ids:'',
        user_ids:'',
        policy_measure_id:'',
        type:0,
        stattime:'',
        yearname:'',
        year:'',
        arrYear:[],
       
     },
     flagdata:false,
     region_level:1,
     policyMeasureTitle:'',
     policyMeasureName:'',
   
    };
  },
  watch:{
        'indexID':function(){
            console.log(22,this.indexID)
            console.log(999,this.markrewardRecord,this.markpolicyMeasure,this.markuser,this.markshow,this.markauditStatusID)
            this.editstep='1'
            this.resetForm()
            this.onpolicydeclarationinfomodelv2(this.valueID,this.markID)
            var now = new Date(); 
            var FullYeartime=now.getFullYear()+"-"+((now.getMonth()+1)<10?"0":"")+(now.getMonth()+1)+"-"+(now.getDate()<10?"0":"")+now.getDate();
            this.ncheckedForm.stattime=new Date(FullYeartime.split(" ")).getTime();
            console.log(FullYeartime,this.checkedForm.stattime) 
            this.funyear()
        },
        filterShowdata(val){
            this.flagdata=val
        },
        
  },
  created: async function () { 
      console.log('this.valueID',this.valueID)
      this.region_level = parseInt(store.getters.adminRegionLevel) +1
    //   this.markshow 展示 0不展示 1乡级审核 2区级级审核 3重申  4年审审核    
    // markauditStatusID 状态值
    // 申请记录id数组 this.markrewardRecord
    // 政策措施ID this.markpolicyMeasure   
    // 申请人用户id数组  this.markuser
     var now = new Date(); 
    var FullYeartime=now.getFullYear()+"-"+((now.getMonth()+1)<10?"0":"")+(now.getMonth()+1)+"-"+(now.getDate()<10?"0":"")+now.getDate();
    this.ncheckedForm.stattime=new Date(FullYeartime.split(" ")).getTime();
      await this.getSystemcodeinfogetlist(13)
      await this.getSystemcodeinfogetlist(18,this.markpolicyMeasure)
      await this.onpolicydeclarationinfomodelv2(this.valueID,this.markID)
      await this.funyear()
  },
  mounted: function () {   
  },
  methods: {
    selectchange(val){
            this.ncheckedForm.noPassReasonList.forEach(e=>{
                if(e.systemCodeID == val){
                    this.ncheckedForm.systemCode = e.systemCode
                }      
            })
            console.log()
   },
          //获取搜索框的不通过原因下拉框
    async getSystemcodeinfogetlist(mark,policyID) {
        await systemcodeModule
            .systemcodeinfogetlist(mark,policyID)
            .then((response) => {
                console.log(1111222,response)
            switch (response.data.code) {
                case 100:{
                    if(mark==13){
                         this.checkedForm.noPassReasonList = response.data.result
                    } else if(mark==18){
                         this.ncheckedForm.noPassReasonList = response.data.result
                    }
                }   
                break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
        });
    },
       //年份
    funyear(){
        var myDate = new Date();       
        var thisYear = myDate.getFullYear();  // 获取当年年份
        this.ncheckedForm.yearname=myDate.getFullYear()
        var Section = thisYear - 2021;  // 声明一个变量 获得当前年份至想获取年份差 eg.2008
        this.ncheckedForm.arrYear = [];
        
        for(var i = 0;i<=Section;i++){
            let obj={
                value:i,
                label:thisYear--
            }
            this.ncheckedForm.arrYear.unshift(obj)
        } // 遍历并添加年份到数组
        this.ncheckedForm.arrYear.forEach(e=>{
            if(this.ncheckedForm.yearname==e.label){
                this.ncheckedForm.year=e.value
            }
        })
        console.log('年份',this.ncheckedForm.arrYear)
    },
    // 审核年份
    checkedFormyearChange(val){
        this.ncheckedForm.arrYear.forEach(e=>{
            if(val==e.value){
                this.ncheckedForm.yearname=e.label
            }
        })
        if(val==-1){
            this.ncheckedForm.yearname=0
        }
        console.log(111111,this.ncheckedForm.yearname)
        // this.searchForm.quarter_array_str=''
    },
    async  onpolicydeclarationinfomodelv2(apply_record_id,mark){
        this.dateContent01={}
        this.dateContent03=[]
        this.img1='',
        this.img2='',
        this.img3='',
        this.img4='',
        this.img5='',
        this.img6='',
        this.img7='',
        this.img8='',
        this.img9='',
        this.img10=[],
        await policydeclarationinfoModule.policydeclarationinfomodelv2(apply_record_id,mark).then((response) => {
                switch (response.data.code) {
                case 100:
                    {
                    this.policyMeasureID=response.data.result.policyMeasureID
                    this.policyMeasureTitle=response.data.result.policyMeasureTitle
                    this.policyMeasureName=response.data.result.policyMeasureName
                    this.dateContent03=[]
                        console.log('response.data.result',response.data.result)

                    let arr=[]
                    response.data.result.lsUser01.forEach(item=>{
                            if(item.applyUserType!==3){
                                if(response.data.result.applyUserID==item.applyUserID){

                                    this.dateContent=item
                                    console.log('5222',this.dateContent)
                                    this.dateContent.userBirthday=publicFun.timestampToTime(this.dateContent.userBirthday).substring(0,10)
                                    this.dateContent.marriageChanges=publicFun.timestampToTime(this.dateContent.marriageChanges).substring(0,10)
                                    this.dateContent.retirementTime=publicFun.timestampToTime(this.dateContent.retirementTime).substring(0,10)
                                    this.dateContent.censusMoveInTime=publicFun.timestampToTime(this.dateContent.censusMoveInTime).substring(0,10)
                                    this.dateContent.censusMoveOutTime=publicFun.timestampToTime(this.dateContent.censusMoveOutTime).substring(0,10)
                                    item.lsRegionParentInfo1.forEach(m=>{
                                    this.dateContent.lsRegionParentInfo1= m.provinceName+m.cityName+m.districtName+m.townshipName+m.villageName
                                    })
                                    item.lsRegionParentInfo2.forEach(m=>{
                                    this.dateContent.lsRegionParentInfo2= m.provinceName+m.cityName+m.districtName+m.townshipName+m.villageName
                                    })
                                    item.lsRegionParentInfo3.forEach(m=>{
                                    this.dateContent.lsRegionParentInfo3= m.provinceName+m.cityName+m.districtName+m.townshipName+m.villageName
                                    })
                                    console.log(5555,this.dateContent.lsRegionParentInfo3)
                                    if(this.dateContent.lsRegionParentInfo3.length==0){
                                        this.dateContent.lsRegionParentInfo3=''
                                    }
                                    console.log('5222',this.dateContent01)
                                }else{
                                    console.log(1111999)
                                    //配偶
                                    this.dateContent01=item
                                    
                                    this.dateContent01.userBirthday=publicFun.timestampToTime(this.dateContent01.userBirthday).substring(0,10)
                                    this.dateContent01.marriageChanges=publicFun.timestampToTime(this.dateContent01.marriageChanges).substring(0,10)
                                    item.lsRegionParentInfo1.forEach(m=>{
                                    this.dateContent01.lsRegionParentInfo1= m.provinceName+m.cityName+m.districtName+m.townshipName+m.villageName
                                        console.log('5222',this.dateContent01)
                                    })
                                }
                            }
                        
                        if(item.applyUserType==3){
                            let isdisability=[]
                            let isWhethertoadopt=[]
                            if(item.physicalConditions==2){
                                isdisability.push(item.physicalConditions)
                            }
                            if(isdisability.length>=1){
                                this.isdisability=true
                            }else{
                                this.isdisability=false
                            }
                            if(item.isAdoption==1){
                                    isWhethertoadopt.push(item.isAdoption)
                            }
                            if(isWhethertoadopt.length>=1){
                                this.isWhethertoadopt=true
                            }else{
                                this.isWhethertoadopt=false
                            }
                            item.lsRegionParentInfo1.forEach(m=>{
                                item.lsRegionParentInfo= m.provinceName+m.cityName+m.districtName+m.townshipName+m.villageName
                            })
                            console.log('子女',this.isWhethertoadopt,item.isAdoption)
                            let obj={
                                ApplicationRecordID03:item.applyUserID,
                                zp1:item.realName,
                                zp2:item.sexID,
                                zp3:publicFun.timestampToTime(item.userBirthday).substring(0,10),
                                zp4:item.certificateNo,
                                zp5:item.relationshipFatherName,
                                zp6:item.relationshipMotherName,
                                zp7:item.physicalConditions,
                                zp17:item.physicalConditionsName,
                                zp8:item.disabilityCertificateNum,
                                zp9:item.disabilityTypeName,
                                zp10:item.disabilityLevelName,
                                zp11: publicFun.timestampToTime(item.disabilityTime).substring(0,10),
                                zp12:item.deathConfirmationUnit,
                                zp18:publicFun.timestampToTime(item.deathTime).substring(0,10),
                                zp13:item.isAdoption,
                                zp15:item.adopteeStatusName,
                                zp16:publicFun.timestampToTime(item.adoptionTime).substring(0,10),
                                zp20:item.isLocalChild,
                                zp19:item.lsRegionParentInfo,
                            }
                            arr.push(obj)
                        }
                        this.dateContent03=arr
                    })
                    response.data.result.lsGallery02.forEach(e=>{
                            if(e.galleryType==1){
                                if(e.galleryUrl){
                                    this.img1=e.galleryUrl
                                }
                            }
                            if(e.galleryType==2){
                                if(e.galleryUrl){
                                    this.img2=e.galleryUrl
                                }
                            }
                            if(e.galleryType==3){
                                if(e.galleryUrl){
                                    this.img3=e.galleryUrl
                                }
                            }
                                if(e.galleryType==4){
                                if(e.galleryUrl){
                                    this.img4=e.galleryUrl
                                }
                            }
                            if(e.galleryType==5){
                                    if(e.galleryUrl){
                                    this.img5=e.galleryUrl
                                }
                            }
                            if(e.galleryType==6){
                                if(e.galleryUrl){
                                    this.img6=e.galleryUrl
                                }
                            }
                            if(e.galleryType==7){
                                if(e.galleryUrl){
                                    this.img9=e.galleryUrl
                                }
                            }
                            if(e.galleryType==8){
                                    if(e.galleryUrl){
                                    this.img7=e.galleryUrl
                                }
                            }
                            if(e.galleryType==9){
                                if(e.galleryUrl){
                                    let obj={
                                        url:e.galleryUrl
                                    }
                                    this.img10.push(obj)
                                }
                                console.log(' this.img10', this.img10)
                            }
                            if(e.galleryType==10){
                                if(e.galleryUrl){
                                    this.img8=e.galleryUrl
                                }
                            }
                        })
                        
                        response.data.result.lsHouse.forEach(e=>{
                            this.dateContent05=e
                        })        
                        
                        console.log(111111111,this.dateContent05)
                    }
                    break;
                case 100002:
                    // this.$message.error(baseconfig.no_permission_message);
                    break;
                default:
                    this.$message.error(response.data.message);
                    break;
                }
            })
            .catch((error) => {});
    },
    resetForm(){
        this.img1='',
        this.img2='',
        this.img3='',
        this.img4='',
        this.img5='',
        this.img6='',
        this.img7='',
        this.img8='',
        this.img9='',
        this.img10=[]
    },

    // 年审审核
    oncheckSubmit(){
         
        if(this.ncheckedForm.is_audit_pass == '0'){
            if(this.ncheckedForm.stattime==''){
                    this.$message.error('请选择年审日期');
                    return
                }
            if( this.ncheckedForm.noPassReason==''){
                this.$message.error('请选择不通过原因');
                    return
            }
        }
        if(this.ncheckedForm.noPassReason==''){
            this.ncheckedForm.noPassReason=0
        }
      
      this.applybatchapprove( `[` + this.markrewardRecord.toString()+ `]` ,  `[` + this.markuser.toString()+ `]` ,`[` + this.markpolicyMeasure.toString()+ `]`,Number(this.ncheckedForm.is_audit_pass) ,this.ncheckedForm.noPassReason,this.ncheckedForm.yearname,this.ncheckedForm.stattime )
    },
    async applybatchapprove(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,audit_year,audit_time)  {
      await rewardannualreviewuserlistModel
        .rewardannualreviewbatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,audit_year,audit_time) 
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                  this.dialogFormVisible = false
                  const h = this.$createElement;
                  this.$notify({
                      title: "成功",
                      message: h("span", response.data.message),
                      type: "success",
                  });
                  this.flagdata= false;
                  this.$emit("getStatedata", this.flagdata);
                }
              break;
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },

    // 申报审核
    // 村级
    oncheckSubmitvillageship(){
          if(this.checkedForm.is_audit_pass == '0'){
            if(this.checkedForm.noPassReasontext==''&& this.checkedForm.noPassReason==''){
                this.$message.error('请输入或选择不通过原因');
                    return
            }
        }
        if(this.checkedForm.noPassReason==''){
            this.checkedForm.noPassReason=0
        }
        this.applybatchaudit( `[` + this.markrewardRecord + `]`,`[` + this.markuser + `]`,this.markpolicyMeasure,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.noPassReasontext,3) 
    },
    // 乡级
    oncheckSubmittownship(){
        if(this.checkedForm.is_audit_pass == '0'){
            if(this.checkedForm.noPassReasontext==''&& this.checkedForm.noPassReason==''){
                this.$message.error('请输入或选择不通过原因');
                    return
            }
        }
        if(this.checkedForm.noPassReason==''){
            this.checkedForm.noPassReason=0
        }
        this.applybatchaudit( `[` + this.markrewardRecord + `]`,`[` + this.markuser + `]`,this.markpolicyMeasure,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.noPassReasontext,1) 
    },
    // 区级
    oncheckSubmitdistrict(){
        if(this.checkedForm.is_audit_pass == '0'){
            if(this.checkedForm.noPassReasontext==''&& this.checkedForm.noPassReason==''){
                this.$message.error('请输入或选择不通过原因');
                    return
            }
        }
        if(this.checkedForm.noPassReason==''){
            this.checkedForm.noPassReason=0
        }
        this.applybatchaudit( `[` + this.markrewardRecord + `]`,`[` + this.markuser + `]`,this.markpolicyMeasure,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.noPassReasontext,2) 
    },
    //申报审核
    async applybatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason,mark) {
      await applyauditModel
        .applybatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason,mark)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                    const h = this.$createElement;
                    this.$notify({
                        title: "成功",
                        message: h("span", response.data.message),
                        type: "success",
                    });
                    this.flagdata= false;
                    this.$emit("getStatedata", this.flagdata); 
                }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },


    // 重申
    oncheckSubmitreiterate(){
         if(this.checkedForm.is_audit_pass == '0'){
            if(this.checkedForm.noPassReasontext==''&& this.checkedForm.noPassReason==''){
                this.$message.error('请输入或选择不通过原因');
                    return
            }
        }
        if(this.checkedForm.noPassReason==''){
            this.checkedForm.noPassReason=0
        }
        this.applyrepeataudit( this.markrewardRecord,this.markuser,this.markpolicyMeasure,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.noPassReasontext) 
    },
    async applyrepeataudit(apply_record_id,user_id,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason) {
      await applyaudit2Model
        .applyrepeataudit(apply_record_id,user_id,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                        const h = this.$createElement;
                        this.$notify({
                            title: "成功",
                            message: h("span", response.data.message),
                            type: "success",
                        });
                         this.flagdata= false;
                         this.$emit("getStatedata", this.flagdata); 
                    }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break; 
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },
    

  }
}
</script>
<style scoped>
.title{
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 10px;
}
.descriptionsheight{
    margin-top: 20px !important;
    min-width: 900px;
}
.descriptionsheight >>>.is-bordered-label{
    width: 168px !important;
    padding: 12px 5px !important;
}
@media only screen and (max-width:1200px) {
   .descriptionsheight >>>.is-bordered-label{
        width: 130px !important;
        padding: 12px 5px !important;
    }
}
.imageitem{
    width:200px;
    text-align: center;
}
.imageitem {
    width:200px;
    height:120px;
    object-fit: cover;
}
.image {
    width:200px;
    height:120px;
    object-fit: cover;
    display: block;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}
.searchtable-img{
    display: flex;
}
.searchtable-img>div+div{
    margin-left: 20px;
}
.searchtableimglist{
    display: flex;
    flex-wrap: wrap;
    min-width: 900px;
}
.searchtableimglist>div{
    width: 50%;
}
.searchtable-item{
    border: 1px solid #E4E7ED;
}
.searchtable-item span{
    width: 200px;
    height: 120px;
    display: block;
}
.searchtable-text{
    border-top: 1px solid #E4E7ED;
    text-align: center;
    padding: 10px;
}
.dialog-footer{
    margin-left: 130px;
}
.checkedForm .el-form{
    width: 60%;
}
</style>